import BaseApi from './BaseApi';

/**
 * LINE問い合わせ最新チャット情報取得API。
 */
class SendCompanyMessageApi extends BaseApi {
  async send(userId: string, message: string) {
    return await this.execute('sendCompanyMessageApi', {
      method: 'POST',
      body: {
        userId,
        message
      }
    }).then(({ status }) => status === 1);
  }
}

export default SendCompanyMessageApi;
